<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-07-24 10:45:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-24 11:00:06
-->
<template>
  <div class="config">
    <Form :model="config"
          action="javascript:void(0)">
      <FormItem label="版本编号"
                prop="number">
        <Input v-model="config.number"
               style="width:500px;"
               placeholder="请输入版本编号"></Input>
      </FormItem>
      <FormItem label="审核"
                label-position="top">
        <RadioGroup v-model="config.is_review">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit()">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
    
    
    <script>
export default {
  name: 'config',
  data () {
    return {
      config: {
        number: '',
        is_review: "0",
      },
    }
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      this.$api.appVersionset.edit(this.config).then(res => {
        if (res.code == 200) {
          this.$Message.success('修改成功...');
        }
      });
    },
    getConfig: function () {
      this.$api.appVersionset.index().then(res => {
        if (res.result) {
          this.config.is_review = res.result.is_review.toString();
          this.config.number = res.result.number;
        } else {
          this.config.is_review = "0"
          this.config.number = "";
        }

      });
    },

  }
}
    </script>